<template>
  <div>
    <b-card title="FAQ" header-tag="header" footer-tag="footer">
      <div slot="header" class="row mb-0 align-items-right">
        <div class="col-12 text-right ">
          <div class="switch-container">
            <span class="switch-label mr-1">
              Status
            </span>

            <toggle-button class="mb-0"
              v-model="form.status"
              :width="70"
              :height="25"
              :labels="{checked: 'Ativo', unchecked: 'Inativo'}"/>
          </div>
        </div>
      </div>

      <p class="card-text">
        As perguntas devem ser do tipo bláblá blá?
      </p>

      <div class="row">
        <b-form-group class="col-12"
          label="* Pergunta"
          label-for="query"
          description="">

          <b-form-input id="query"
            type="text"
            v-model="form.query"
            required
            placeholder="Pergunta"
            :class="{
              'is-invalid': submitted && form.errors.has('query'),
              'is-valid': submitted && !form.errors.has('query')
            }"></b-form-input>
        </b-form-group>

        <b-form-group class="col-12"
          label="* Resposta"
          label-for="answer"
          description="">

          <b-form-textarea id="answer"
            v-model="answer"
            placeholder="Resposta"
            required
            :class="{
              'is-invalid': submitted && form.errors.has('answer'),
              'is-valid': submitted && !form.errors.has('answer')
            }"
            :rows="10">
          </b-form-textarea>
        </b-form-group>
      </div>

      <slot name="footer">
        <div slot="footer" class="text-right">

          <b-button type="submit" variant="success">
            Salvar
          </b-button>
        </div>
      </slot>
    </b-card>
  </div>
</template>

<script>
import { set } from 'lodash'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () { return {} }
    }
  },

  data () {
    return {
      answer: '',

      empty: {
        query: '',
        answer: '',
        status: true
      }
    }
  },

  watch: {
    answer (next) {
      set(this.form, 'answer', next)
    }
  },

  created () {
    if (this.instance.id) {
      this.form.withData(this.instance).setInitialValues(this.instance)
      this.answer = this.instance.answer
    } else {
      this.form.withData(this.empty).setInitialValues(this.empty)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/Bl/Question.vue